/**
 * Mirror of lib/gemini.ts#findExistingByType for the client — used to decide
 * whether to show "Augment existing" vs "Generate" on a detection card.
 */
export function hasExistingOfType(
  existingJsonLd: unknown[],
  typeName: string
): boolean {
  for (const root of existingJsonLd) {
    if (findInNode(root, typeName)) return true;
  }
  return false;
}

function findInNode(node: unknown, typeName: string): boolean {
  if (!node) return false;
  if (Array.isArray(node)) {
    for (const item of node) {
      if (findInNode(item, typeName)) return true;
    }
    return false;
  }
  if (typeof node !== 'object') return false;
  const obj = node as Record<string, unknown>;
  const t = obj['@type'];
  if (
    (typeof t === 'string' && t === typeName) ||
    (Array.isArray(t) && t.includes(typeName))
  ) {
    return true;
  }
  for (const value of Object.values(obj)) {
    if (value && typeof value === 'object') {
      if (findInNode(value, typeName)) return true;
    }
  }
  return false;
}
